import {config, dom, library} from '@fortawesome/fontawesome-svg-core'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {fal} from '@fortawesome/pro-light-svg-icons'

config.mutateApproach = 'sync'

library.add(fab)
library.add(fal)

// Scope the icon replacement to <body>. Left at the document root, Font
// Awesome's scan also walks <head> and strips the document <title> (it treats
// <title> as an SVG accessibility node), which wiped the page title on every
// page load.
dom.watch()